document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('slider-component ul.slider');

  sliders.forEach(slider => {
    let startX = 0;
    let isDragging = false;

    const card = slider.querySelector('.grid__item');
    if (!card) return;
    const cardWidth = card.offsetWidth + parseInt(getComputedStyle(card).marginRight);

    // Prevent default drag behavior on images and links inside cards
    slider.querySelectorAll('img, a, button').forEach(el => {
      el.setAttribute('draggable', 'false');
    });

    // Mouse events
    slider.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX;
      e.preventDefault(); // prevent text/image selection
    });

    slider.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const endX = e.pageX;
      handleSwipe(endX - startX);
    });

    // slider.addEventListener('mouseleave', () => {
    //   isDragging = false;
    // });

    // slider.addEventListener('mousemove', (e) => {
    //   if (!isDragging) return;
    //   e.preventDefault();
    // });

    // Touch events
    slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX;
    });

    slider.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].pageX;
      handleSwipe(endX - startX);
    });

    // slider.addEventListener('touchmove', (e) => {
    //   e.preventDefault();
    // });

    function handleSwipe(distance) {
      const threshold = 30;
      if (distance > threshold) {
        slider.scrollBy({ left: -cardWidth, behavior: 'smooth' });
      } else if (distance < -threshold) {
        slider.scrollBy({ left: cardWidth, behavior: 'smooth' });
      }
    }
  });
});
